import { useState, useCallback, lazy, Suspense } from 'react';

import { useDeviceViewport } from '@/hooks/useViewport';
import useUserProfile from '@/hooks/useUserProfile';
import { pushBrowserNav } from '@/hooks/useBrowserHistory';
import Header from '@/components/Header';
import SettingsPanel from '@/components/SettingsPanel';
import { SettingsPanelVariant } from '@/components/SettingsPanel/types';
import AppLayout from '@/components/AppLayout';

import ResultOverlay from '../ResultOverlay';
import useAppNavigation from '@/hooks/useAppNavigation';
import ToastSurface from '../ToastSurface';
import MobileLayout from '../MobileLayout';
import useStyles from './styles';

const DesktopLayout = lazy(() => import('../DesktopLayout'));

const AppShell = () => {
  const classes = useStyles();
  const { isMobile } = useDeviceViewport();
  const { isAuthorized: userIsAuthorized } = useUserProfile();

  const [showMobileSettings, setShowMobileSettings] = useState(false);

  const onBackFromSettings = useCallback(() => {
    setShowMobileSettings(false);
  }, []);

  useAppNavigation({ onBackFromSettings });

  const handleOpenSettings = useCallback(() => {
    setShowMobileSettings(true);
    pushBrowserNav('settings');
  }, []);

  return (
    <div className={classes.root}>
      <AppLayout
        header={
          <Header
            hideBack={showMobileSettings && isMobile}
            onSettingsClick={handleOpenSettings}
          />
        }
        isMobile={isMobile}
      >
        {showMobileSettings && isMobile ? (
          <SettingsPanel
            variant={SettingsPanelVariant.Page}
            onBack={onBackFromSettings}
            isAuthorized={userIsAuthorized}
          />
        ) : isMobile ? (
          <MobileLayout />
        ) : (
          <Suspense fallback={null}>
            <DesktopLayout />
          </Suspense>
        )}
      </AppLayout>
      <ResultOverlay />
      <ToastSurface />
    </div>
  );
};

export default AppShell;
